///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { format, parseISO } from "date-fns";
import { forEach, groupBy, sortBy, sumBy } from "lodash";

import { round } from "./laneCalculations";
import { dateFormat } from "./types";

const mapLineGraphDetails = loads => {
  let data = [];

  forEach(
    groupBy(loads, ({ loadDate }) =>
      format(parseISO(loadDate), dateFormat.yyyMM)
    ),
    (group, key) => {
      const sumOfMiles = sumBy(group, "miles");
      const sumOfCost = sumBy(group, "cost");
      data.push({
        year: key.split("-")[0],
        month: key.split("-")[1],
        volume: group.length,
        averageCost: round(sumOfCost / group.length),
        averageCpm:
          sumOfMiles === 0
            ? round(sumOfCost / group.length)
            : round(sumOfCost / sumOfMiles),
        yearMonth: key
      });
    }
  );

  data = sortBy(data, "yearMonth");

  return data;
};

export default mapLineGraphDetails;
